import moment from 'moment';
import compact from 'lodash.compact';

// eslint-disable-next-line complexity
export default (menuFileContent, officeId, events) => {
  const dataFromFile = menuFileContent.split('\r\n').filter((line) => line.trim() !== '');

  const rowDataFromFile = dataFromFile.map((row) => row.split('\t'));
  const minDataRows = 4;
  const minDataColumns = 4;

  const messagesTemplate = 'admin.orderParserMessages';

  if (rowDataFromFile.length < minDataRows) {
    throw new Error(`${messagesTemplate}.minDataRows`);
  }

  if (rowDataFromFile[2].length < minDataColumns) {
    throw new Error(`${messagesTemplate}.minDataColumns`);
  }

  const dates = rowDataFromFile[1].slice(3);
  const startDate = dates[0];
  const endDate = dates[dates.length - 1];

  dates.forEach((date) => {
    if (!date || date.split('-').length !== 3 || !moment(date).isValid()) {
      throw new Error(`${messagesTemplate}.dateFormat`);
    }
  });

  if (!rowDataFromFile[0][0] || rowDataFromFile[0][0].toLowerCase().trim() !== 'catering') {
    throw new Error(`${messagesTemplate}.firstRowFormat`);
  }

  if (!rowDataFromFile[2][0] || rowDataFromFile[2][0].toLowerCase().trim() !== 'event') {
    throw new Error(`${messagesTemplate}.thirdRowFormat`);
  }

  if (!rowDataFromFile[2][1] || rowDataFromFile[2][1].toLowerCase().trim() !== 'email') {
    throw new Error(`${messagesTemplate}.fourthRowFormat`);
  }

  if (!rowDataFromFile[2][2] || rowDataFromFile[2][2].toLowerCase().trim() !== 'name') {
    throw new Error(`${messagesTemplate}.fifthRowFormat`);
  }

  const ordersData = rowDataFromFile.slice(3);

  const normalizeString = (string) =>
    string
      .toLowerCase()
      .replace(/"/g, '')
      .trim();

  /* eslint no-param-reassign: 0 */
  const extractUsersAndOrders = (orderDataAccumulator, currentOrderData) => {
    const event = normalizeString(currentOrderData[0]);
    const email = normalizeString(currentOrderData[1]);
    const name = currentOrderData[2];

    const orders = currentOrderData.slice(3);

    if (event && email) {
      orders.forEach((order, index) => {
        const eventObj = events.find(({ name }) => name.toLowerCase() === event.toLowerCase());

        if (order) {
          orderDataAccumulator.push({
            order,
            email,
            name,
            date: dates[index],
            event: eventObj.id,
          });
        } else {
          throw new Error(`${messagesTemplate}.noMeal`);
        }
      });
    }
    return orderDataAccumulator;
  };

  const eventMeals = ordersData.reduce(extractUsersAndOrders, []);

  return {
    startDate,
    endDate,
    office: officeId,
    orderEvents: compact(eventMeals).flat(),
  };
};



// WEBPACK FOOTER //
// ./src/utils/bulkOrdersParser.js